import React, { useState, useContext } from "react";
import AppContext from "../../../context/appContext";
import Pagination from "react-js-pagination";

const SearchPagination = (props) => {
  const { pagination } = props;

  const appContext = useContext(AppContext);

  const [currentPage, setCurrentPage] = useState({
    ...appContext.filter,
    PageNumber: pagination?.pageIndex,
  });

  const handlePageChange = (page) => {
    appContext.setFilterSearch({ ...currentPage, PageNumber: page });
    setCurrentPage({ ...currentPage, PageNumber: page });
  };

  if (!pagination) return <div />;

  const { pageIndex, pageSize, totalCount, hasPreviousPage, hasNextPage } = pagination;

  return (
    <div id="PaginationContent">
      <div
        className={`prevPagination ${hasPreviousPage ? "hasPage" : ""}`}
        onClick={hasPreviousPage ? () => handlePageChange(pageIndex - 1) : null}
      >
        <span className="prevArrow" />
        <span className="prevArrow" />
      </div>

      <Pagination
        hideNavigation
        hideFirstLastPages
        activePage={pageIndex}
        itemsCountPerPage={pageSize}
        totalItemsCount={totalCount}
        onChange={handlePageChange}
        hideDisabled
      />

      <div
        className={`nextPagination ${hasNextPage ? "hasPage" : ""}`}
        onClick={hasNextPage ? () => handlePageChange(pageIndex + 1) : null}
      >
        <span className="nextArrow" />
        <span className="nextArrow" />
      </div>
    </div>
  );
};

export default SearchPagination;
